"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
exports.stepsReducer = function (state, action) {
    var _a;
    switch (action.type) {
        case 'SET_STEPS':
            return tslib_1.__assign(tslib_1.__assign({}, state), action.value);
        case 'REPLACE_STEPS':
            return tslib_1.__assign({}, action.value);
        case 'GO_TO_STEP':
            return Object.keys(state).reduce(function (acc, key) {
                var _a;
                return tslib_1.__assign(tslib_1.__assign({}, acc), (_a = {}, _a[key] = tslib_1.__assign(tslib_1.__assign({}, state[key]), { isEdit: key === action.value }), _a));
            }, {});
        case 'COMPLETE_STEP':
            return tslib_1.__assign(tslib_1.__assign({}, state), (_a = {}, _a[action.value] = { isEdit: false, isComplete: true }, _a));
        default:
            return state;
    }
};
//# sourceMappingURL=stepsReducer.js.map